import React, { FC } from 'react'
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import Tooltip from '~/components/common/Tooltip'

type Props = {
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  disabled: boolean
}

/**
 *
 * może być potrzeba, by getRootProps kasować, gdy jest isDraggingOverWindow
 *
 * bo wtedy są dwa aktywne getRootProps na stronie
 */

const Upload: FC<Props> = ({ getInputProps, getRootProps, disabled }) => {
  return (
    <Tooltip
      content={intl.formatMessage({
        id: 'chat / input / upload',
      })}
    >
      <button {...getRootProps()} type="button" disabled={disabled}>
        <span className="far fa-paperclip" />

        <input {...getInputProps()} />
      </button>
    </Tooltip>
  )
}

export default Upload
